class Newsletter extends ViewBasic {
	constructor(options) {
		super(options);

		//set default variables
	}

	init() {

		this.form = new Me.form(this.$el, {
			form_scope: this,
			fields: [
				{name: 'email', type: 'email'}
			],
			onSuccess: this.formSuccessHandler,
			onValidationSuccess: $.proxy(this.formValidationSuccessHandler, this),
			onError: this.formErrorHandler,
		});

		this.addEvents();
	}

	addEvents() {

	}

	removeEvents() {

	}

    formSuccessHandler() {

	}

	formErrorHandler(error){
		this.$('.error-message').addClass('hide');
		this.$('.error-message.error').removeClass('hide');
	}

	formValidationSuccessHandler(){
        Me.dispatch.emit('modal-trigger', this, {name: 'newsletter-popup', fixedMobile: true});
	}

}